// Create the script tag, set the appropriate attributes
var script = document.createElement("script");
var ambiente = window.location.hostname;
var apiKey = '';

if(ambiente.includes('int') || ambiente.includes('uat') || ambiente.includes('local')) {
  apiKey = "AIzaSyCQQN61xVGk0Z4vtJ-A22On-84cRA386mQ"
} else {
  apiKey = "AIzaSyDnqdPlfrk-Vvynkx1vcbA53mKGL4XA1dc"
}
  // script.src =
  //   "https://maps.googleapis.com/maps/api/js?key=AIzaSyDnqdPlfrk-Vvynkx1vcbA53mKGL4XA1dc&callback=initMap&libraries=places";
  script.src =
    "https://maps.googleapis.com/maps/api/js?key=" + apiKey + "&callback=initMap&libraries=places";


script.async = true;
// Attach your callback function to the `window` object
window.initMap = function () {
  // JS API is loaded and available
};

// Append the 'script' element to 'head'
document.head.appendChild(script);
